import { memo, useState, useCallback } from 'react';
import { cn, Collapse } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import styles from './Accordion.module.css';

import type { FC, HTMLAttributes, ReactChild } from 'react';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  header: string | ReactChild;
  defaultCollapsed?: boolean;
  children?: ReactChild;
  disabled?: boolean;
}

const Accordion: FC<AccordionProps> = (props) => {
  const { header, children, defaultCollapsed, disabled } = props;
  const [collapsed, setCollapsed] = useState<boolean>(defaultCollapsed);
  const { isMobileS } = useMedias();

  const handleClickHeader = useCallback(() => {
    if (!isMobileS || disabled) {
      return;
    }

    setCollapsed(!collapsed);
  }, [disabled, collapsed, isMobileS]);

  return (
    <div
      className={cn(styles.accordion, {
        [styles.disabled]: disabled === true,
        [styles.collapsed]: collapsed === true,
      })}
    >
      <div className={cn(styles.header)} onClick={handleClickHeader}>
        {header}
      </div>

      {isMobileS ? (
        <Collapse collapsed={collapsed}>
          <div className={styles.content}>{children}</div>
        </Collapse>
      ) : (
        <div className={styles.content}>{children}</div>
      )}
    </div>
  );
};

export default memo(Accordion);
